/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContentListEntryFromJSON, ContentListEntryToJSON, DateRangeFromJSON, DateRangeToJSON, MetaDataFromJSON, MetaDataToJSON, NamedResourceTagFromJSON, NamedResourceTagToJSON, PlayerListEntryFromJSON, PlayerListEntryToJSON, TimeRangeOfDayFromJSON, TimeRangeOfDayToJSON, } from './';
export function CampaignResponseFromJSON(json) {
    return CampaignResponseFromJSONTyped(json, false);
}
export function CampaignResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'duration': !exists(json, 'duration') ? undefined : DateRangeFromJSON(json['duration']),
        'contents': !exists(json, 'contents') ? undefined : (json['contents'].map(ContentListEntryFromJSON)),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(NamedResourceTagFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'organisationId': !exists(json, 'organisationId') ? undefined : json['organisationId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'active': json['active'],
        'timePlan': !exists(json, 'timePlan') ? undefined : (json['timePlan'].map(TimeRangeOfDayFromJSON)),
        'targetPlayers': !exists(json, 'targetPlayers') ? undefined : (json['targetPlayers'].map(PlayerListEntryFromJSON))
    };
}
export function CampaignResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'duration': DateRangeToJSON(value.duration),
        'contents': value.contents === undefined ? undefined : (value.contents.map(ContentListEntryToJSON)),
        'metaData': MetaDataToJSON(value.metaData),
        'tags': value.tags === undefined ? undefined : (value.tags.map(NamedResourceTagToJSON)),
        'name': value.name,
        'organisationId': value.organisationId,
        'userId': value.userId,
        'active': value.active,
        'timePlan': value.timePlan === undefined ? undefined : (value.timePlan.map(TimeRangeOfDayToJSON)),
        'targetPlayers': value.targetPlayers === undefined ? undefined : (value.targetPlayers.map(PlayerListEntryToJSON))
    };
}
